<template>
  <div class="container">
    <div class="header">
      <button @click="cancel">取消</button>
      <form action="/">
        <van-search
          v-model="searchText"
          placeholder="搜寻"
        />
      </form>
      <button :disabled="list.filter(item => item.selected).length <= 0" @click="confirm">确认</button>
    </div>
    <div class="body">
      <van-list v-if="filteredList.length > 0">
        <van-cell 
          v-for="item in filteredList" 
          :key="item.title" 
          :title="item.title" 
          @click="() => selectItem(item)"
        >
          <template v-if="item.selected" #right-icon>
            <van-icon name="success" size="0.4rem" />
          </template>
        </van-cell>
      </van-list>
      <div v-else class="no-results">
        没有结果
      </div>

    </div>
  </div>
</template>

<script>
require('@/assets/css/selectWithSearch.css')

export default {
  name: 'SelectWithSearch',
  props: ['selectList', 'selectedKey'],
  data() {
    return {
      list: this.selectList.map(item => ({ ...item, selected: item.key === this.selectedKey })),
      searchText: ''
    }
  },
  computed: {
    filteredList() {
      return this.list.filter(item => item.title.includes(this.searchText))
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      const item = this.list.find(item => item.selected)
      const selectedItem = {
        key: item.key,
        title: item.title
      }
      this.$emit('confirm', selectedItem)
    },
    selectItem(item) {
      this.list = this.list.map(o => ({ ...o, selected: o.title == item.title ? !o.selected : false }))
    },
  }
}
</script>